export class SettingsCategoryTagsEntity {
  constructor() {
    this.id = null;
    this.enabledFlag = null;
    this.tagName = null;
  }
  getSettingsCategoryTagsEntity() {
    return this;
  }
  setEnabledFlag(flag) {
    this.enabledFlag = flag;
  }
  getEnabledFlag() {
    return this.enabledFlag;
  }
}

export default SettingsCategoryTagsEntity;
